var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable react/display-name,complexity */
import React, { forwardRef } from 'react';
import cx from 'classnames';
import { Container, Typography } from '../';
import * as S from './styles';
export var Radio = forwardRef(function Radio(props, ref) {
    var id = props.id, name = props.name, disabled = props.disabled, variant = props.variant, label = props.label, color = props.color, required = props.required, onChange = props.onChange, value = props.value, radioValue = props.radioValue, className = props.className, style = props.style, rest = __rest(props, ["id", "name", "disabled", "variant", "label", "color", "required", "onChange", "value", "radioValue", "className", "style"]);
    var onChangeHandler = function (event) {
        if (onChange)
            onChange(event, !value);
    };
    var colorClass = color + "-color";
    var variantClass = variant + "-variant";
    var disabledClass = disabled ? 'is-disabled' : false;
    var isClickableClass = onChange ? 'is-clickable' : false;
    var isActiveClass = radioValue === value ? 'is-active' : 'is-empty';
    var isColoredClass = variant === 'radioColored' ? 'is-colored' : false;
    var wrapperClass = cx(disabledClass, isClickableClass, variantClass, className);
    var radioVariantClass = cx(variantClass, isActiveClass, colorClass, isColoredClass);
    return (React.createElement(S.RadioWrapper, { htmlFor: id, className: wrapperClass },
        React.createElement(S.RadioInput, __assign({ id: id, name: name, disabled: disabled, required: required, onChange: onChangeHandler, checked: radioValue === value, value: radioValue, style: style, ref: ref, type: 'radio' }, rest)),
        React.createElement(Container, null,
            React.createElement(S.RadioVariant, { className: radioVariantClass })),
        label && (React.createElement(Container, { left: 'xsmall' },
            React.createElement(Typography, { as: 'span', color: disabled ? 'light' : undefined }, label)))));
});
Radio.defaultProps = {
    disabled: false,
    color: 'black'
};
Radio.displayName = 'Radio';
export default Radio;
//# sourceMappingURL=Radio.js.map